<script setup lang="ts">
defineProps<{
  disclaimer: string
  linkText?: string
  linkTo?: string
  postText?: string
}>()
</script>

<template>
  <div class="text-gray-500 text-sm border-t border-gray-200 pt-8">
    <p>
      {{ disclaimer }}
      <template v-if="linkText && linkTo">
        <NuxtLink
          :to="linkTo"
          class="text-primary-700 hover:text-primary-900 underline"
        >{{ linkText }}</NuxtLink>
        {{ postText || "" }}
      </template>
    </p>
  </div>
</template>
